import { render, staticRenderFns } from "./EventDetailItem1.vue?vue&type=template&id=1ab43348"
import script from "./EventDetailItem1.vue?vue&type=script&lang=ts"
export * from "./EventDetailItem1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports